import testimonialsData from '../data/testimonials.json';
import { type Testimonial, testimonialsByProgramKeySchema } from '../models/testimonials';

const testimonialsByProgramKey = testimonialsByProgramKeySchema.parse(testimonialsData);

export function getTestimonials(programKey: string): Testimonial[] | null {
  return testimonialsByProgramKey[programKey] ?? null;
}
